<div class="content-wrapper">
  <form nz-form nzLayout="vertical" [formGroup]="exportAudienceForm">
    <nz-form-item>
      <nz-form-label nzFor="targetChannel" [nzRequired]="true" class="nfl-form-label padding-bottom0"
        >Target Channel</nz-form-label
      >
      <nz-form-control>
        <span id="targetChannel" nz-typography>{{ activationChannel.channelType }}</span>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label nzFor="audienceFrom" [nzRequired]="true" class="nfl-form-label">Audience From</nz-form-label>
      <nz-form-control>
        <nz-radio-group formControlName="audienceFrom">
          <label nz-radio [nzValue]="audienceTypes.QUERY">Query</label>
          <label nz-radio [nzValue]="audienceTypes.LOOKALIKE_MODEL">Lookalike Model</label>
        </nz-radio-group>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item *ngIf="audienceFromControl.value === audienceTypes.QUERY">
      <nz-form-label nzFor="selectAudience" [nzRequired]="true" class="nfl-form-label">Select Audience</nz-form-label>
      <nz-form-control>
        <nz-select
          nzShowSearch
          nzAllowClear
          nzPlaceHolder="Select a Query Name of List result"
          formControlName="queryId"
          (ngModelChange)="handleAudienceSelect()"
          [nzNotFoundContent]="loadingQueries ? loadingTemplate : undefined"
        >
          <nz-option
            [nzLabel]="getOptionDisplayName(option)"
            [nzValue]="option.queryId"
            *ngFor="let option of selectAudienceOptions; index as i"
          >
          </nz-option>
        </nz-select>

        <!-- Custom loading content -->
        <ng-template #loadingTemplate>
          <span>
            <i nz-icon nzType="loading" class="mr-1"></i>
            Loading data...
          </span>
        </ng-template>
      </nz-form-control>
    </nz-form-item>

    <!-- Lookalike Model Selection -->
    <nz-form-item *ngIf="audienceFromControl.value === audienceTypes.LOOKALIKE_MODEL">
      <nz-form-label nzFor="selectLookalikeModel" [nzRequired]="true" class="nfl-form-label"
        >Select Lookalike Model</nz-form-label
      >
      <nz-form-control>
        <nz-select
          nzShowSearch
          nzAllowClear
          nzPlaceHolder="Select a Lookalike Model"
          formControlName="queryId"
          (ngModelChange)="handleAudienceSelect()"
          [nzNotFoundContent]="loadingModels ? modelLoadingTemplate : undefined"
        >
          <nz-option
            [nzLabel]="getModelDisplayName(model)"
            [nzValue]="model.modelId"
            *ngFor="let model of selectModelOptions; index as i"
          >
          </nz-option>
        </nz-select>

        <!-- Custom loading content for models -->
        <ng-template #modelLoadingTemplate>
          <span>
            <i nz-icon nzType="loading" class="mr-1"></i>
            Loading models...
          </span>
        </ng-template>
      </nz-form-control>
    </nz-form-item>

    <!-- META Channel Credentials - with form control and form group -->
    <ng-container *ngIf="activationChannel.channelType === 'META'">
      <nz-form-item>
        <nz-form-label nzFor="expireAt" [nzRequired]="true" class="nfl-form-label">Expiry Date</nz-form-label>
        <nz-form-control>
          <nz-date-picker
            class="w100"
            nzPlaceHolder="Select Expiry Date"
            formControlName="expireAt"
            [nzDisabledDate]="disabledDate"
            [nzFormat]="'MM/dd/YYYY'"
          ></nz-date-picker>
        </nz-form-control>
      </nz-form-item>

      <p nz-typography *ngIf="queryRecord || selectedModel" class="nfl-form-label">Attributes Mappings</p>
      <nz-form-item
        class="attributes-mappings"
        *ngFor="let attributesMapping of attributesMappingFormArray.controls; let i = index"
        [formGroup]="attributesMapping"
      >
        <div>
          <nz-form-label class="nfl-form-label">Attribute</nz-form-label>
          <nz-form-control>
            <ng-container> {{ attributesMapping.value.attribute }}</ng-container>
          </nz-form-control>
        </div>

        <div>
          <nz-form-label class="nfl-form-label" [nzRequired]="true">Mapping</nz-form-label>
          <nz-form-control class="mapping-dropdown">
            <nz-select formControlName="mapping" nzPlaceHolder="Select Mapping">
              <nz-option
                *ngFor="let option of mappingOptions"
                [nzValue]="option.value"
                [nzLabel]="option.title"
              ></nz-option>
            </nz-select>
          </nz-form-control>
        </div>

        <div class="guidelines-container">
          <nz-form-label *ngIf="attributesMapping.value.mapping" class="nfl-form-label">Guidelines</nz-form-label>
          <nz-form-control>
            <ng-container>
              <span nz-typography nzEllipsis [nz-tooltip]="getGuidelines(attributesMapping.value.mapping)">
                {{ getGuidelines(attributesMapping.value.mapping) }}
              </span>
            </ng-container>
          </nz-form-control>
        </div>
      </nz-form-item>
    </ng-container>

    <!-- GOOGLE Channel Credentials - with form control and form group -->
    <ng-container *ngIf="activationChannel.channelType === 'GOOGLE'">
      <nz-form-item>
        <nz-form-label nzFor="expireAt" [nzRequired]="true" class="nfl-form-label">Expiry Date</nz-form-label>
        <nz-form-control>
          <nz-date-picker
            class="w100"
            nzPlaceHolder="Select Expiry Date"
            formControlName="expireAt"
            [nzDisabledDate]="disabledDate"
            [nzFormat]="'MM/dd/YYYY'"
          ></nz-date-picker>
        </nz-form-control>
      </nz-form-item>
      <p nz-typography *ngIf="queryRecord || selectedModel" class="nfl-form-label">Attributes Mappings</p>
      <nz-form-item
        class="attributes-mappings"
        *ngFor="let attributesMapping of attributesMappingFormArray.controls; let i = index"
        [formGroup]="attributesMapping"
      >
        <div>
          <nz-form-label class="nfl-form-label">Attribute</nz-form-label>
          <nz-form-control>
            <ng-container> {{ attributesMapping.value.attribute }}</ng-container>
          </nz-form-control>
        </div>

        <div>
          <nz-form-label class="nfl-form-label" [nzRequired]="true">Mapping</nz-form-label>
          <nz-form-control class="mapping-dropdown">
            <nz-select formControlName="mapping" nzPlaceHolder="Select Mapping">
              <nz-option
                *ngFor="let option of googleMappingOptions"
                [nzValue]="option.value"
                [nzLabel]="option.title"
              ></nz-option>
            </nz-select>
          </nz-form-control>
        </div>
      </nz-form-item>
    </ng-container>

    <!-- S3 Channel Credentials - with form control and form group -->
    <ng-container *ngIf="activationChannel.channelType === 'S3'">
      <nz-form-item>
        <nz-form-label [nzRequired]="false" nzFor="folderPath" class="nfl-form-label">Folder Path</nz-form-label>
        <nz-form-control [nzErrorTip]="folderPathErrorTemplate">
          <input nz-input id="folderPath" formControlName="folderPath" placeholder="Folder Path" />
        </nz-form-control>
      </nz-form-item>
      <ng-template #folderPathErrorTemplate let-control>
        <div>
          Please enter a valid S3 folder path using letters, numbers, hyphens (-), underscores (_), slashes (/), or dots
          (.). The path must not start with a slash or contain consecutive slashes.
        </div>
      </ng-template>

      <nz-form-item>
        <nz-form-label [nzRequired]="true" nzFor="fileType" class="nfl-form-label">File Type</nz-form-label>
        <nz-form-control>
          <nz-select nzPlaceHolder="File Type" formControlName="fileType" id="fileType" nzSize="large">
            <nz-option
              [nzLabel]="type.name"
              [nzValue]="type.value"
              *ngFor="let type of fileTypes; index as i"
            ></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </ng-container>

    <div class="w100 export-button">
      <button
        nz-button
        nzSize="large"
        nzType="primary"
        nzOutline
        (click)="exportAudience()"
        [nzLoading]="isLoading"
        [disabled]="canExport"
      >
        Export
      </button>
    </div>
  </form>
</div>
